import useOldLang from '../../hooks/useOldLang';
import React, { FC } from '../../lib/teact/teact';
import Button from '../ui/Button';

export const BroIntro: FC<{setDone: ()=> void}> = ({setDone}) => {
  return <div id="auth-intro" className="custom-scroll">
      <div className="auth-form">
          <div id="logo" />
          <p>
            This app is a <s>pretty basic fork of</s> HUGE improvement on the telegram web app,{' '}
            and a homage to the 'Bro2Bro' app of 'Silicon Valley' S02E02.<br />
            As we're <s>dumb</s> a fast-paced startup, we don't run our own infrastructure, so:{' '}
            <strong>You will need to log in to a normal telegram account</strong>
          </p>
          <p>
            The people you chat with <i>will</i> be able to reply with unnecessary details...{' '} 
            but <i>you</i> will have the benefit{' '}
            of only communicating via the one true bit of information.<br />
          </p>
          <p>
            <a href="https://gitlab.com/TeNNoX/bro" target="_blank">find out details & <strong>our source code here</strong></a>,{' '}
            and also a <a href="https://gitlab.com/TeNNoX/bro/-/compare/upstream...main" target="_blank">direct comparison</a> with original telegram code,{' '}
            if you want to verify which code you're trusting with your tasteful GIF library.<br/>
            (but.. trust me bro)
          </p>
          <Button ripple onClick={setDone}>Log in to telegram</Button>
      </div>
  </div>
}
